/* 
 * HTTP 请求服务接口扩展
 * 封装客户端向服务器发送的HTTP请求（GET、POST）
 * 封装的请求，已加入MYPROID授权码和请求服务器主地址，使用时不用再加入
 * 已封装HTPP相关URL地址的处理，支持URL地址参数根据参数名称获取其值
 */
'use strict'

import 'es6-promise/auto';
import JSMD5 from 'js-md5'; //MD5加密
import axios from 'axios';
import iView from 'view-design';

var SIGNKEY = {
  "K0": "&kK-o+./?*#pK3;Z*n}o%Bh#pK#xl:SJ[",
  "K1024": "2be4f808d7e120553fd52934728bbc70",
  "Kcpl20623": "a70ecbee23fcdd5130ee89cc461a3d32",
  "Kcpl20801": "19fef1738b0c1a06d752c66386a0c049",
  "Kcpl20736": "02ff79b136b21f60688106515f0e28d0",
  "Kcpl20740": "fef25638d2058331714bac00a3bb9d36",
  "Kcpl20731": "ed4edac63aac6a16af5c2b61df2881f9",
  "Kcpl20725": "1a43b16aca511d4a964adaab6cae1158",
  "Kcpl73011": "491badf20bc0362958942731913e5035",
  "Kcpl73031": "a71e187ebf27094f0f6de7de007bf379",
  "Kcpl73012": "1b6911cdb79da88e9da591489467db06",
  "Kcpl73015": "e5757dc82f9b22a83911a35c5be4dbeb",
  "Kcpl73016": "0e5a81d9240f6f9b023724dc347a53d6",
  "Kcpl73018": "564c0b3dc5b47f8f4d40a51f70f409cd",
  "Kcpl73020": "0fe007d7cdd228dda61ce32ddfa55aac",
  "Kcpl73021": "43a27db185bb84902d57e9db779672cd",
  "Kcpl73032": "743d5b2edc0eaf4947154ea32c0a8ffd",
  "Kcpl73033": "362b6b2f86c6f6c9a0ee231b0bfc57cb",
  "Kcpl73034": "6d80ccbe58893ff059a94eaf58f69f13",
  "Kcpl73035": "b9850610715b81497f7a53f77d09f1de",
  "Kcpl73038": "ae402e686a2ab526a32ae7e0b53922fe",
  "Kcpl79015": "38015318b0849bb626fec4ed295b2250",
  "Kcpl79020": "2ba50329f6e62a9f859e16a3a91f2424",
};
var REQUEST_HEAD = "application/x-www-form-urlencoded";
/**
 * 处理请求数据
 * @param data object 当前请求数据
 */
var PostLocalData = function (data) {
  if (REQUEST_HEAD.indexOf("www-form-url") > 0){
    let _data = undefined;
    // JSON字符串处理
    if (typeof(data) == "string") { try{ _data = JSON.parse(data); } catch(e) { _data = undefined; } }
    // JSON对象处理
    if (typeof(data) == "object") {
      if (Object.prototype.toString.call(data).toLowerCase() == "[object object]" && !data.length) { _data = data; }
      else if (Object.prototype.toString.call(data).toLowerCase() == "[object array]") { _data = JSON.parse(JSON.stringify(data)); }
    }
    if (_data != undefined) {
      let refData = [];
      for (let key in _data) { refData.push(key + '=' + encodeURIComponent(_data[key])); }
      data = refData.join('&');
    }
  }
  return data;
};
/**
 * 基础请求函数实现
 * @param method string 请求方法[get,post]
 * @param url    string 请求命令，也可以是完整的请求地址
 * @param data     json 请求数据，GET组合至URL地址请求
 * @param yes  function 请求成功回调执行[result,status,JsXHR]
 * @param err  function 请求异常回调执行[error]
 */
var HttpClient = function(method, url, data, yes, err, timeout) {
  method = method.toLowerCase();
  iView.LoadingBar.start();

  url = url.replace(/(^\s*)|(\s*$)/g, ""); 
  if (method == "get" && data != undefined) {
    var args = [], sepat = url.indexOf('?') >= 0 ? '&' : '?';
    for (var ekey in data) { args.push(ekey + '=' + data[ekey]); }
    url = url + (args.length > 0 ? sepat + args.join('&') : '');
  }
  if (timeout==undefined) { timeout = 10000; }
  
  var instarg = axios.create({ timeout: timeout });
  switch(method){
    case "get": 
      instarg.get(url)
        .then(function(result) { iView.LoadingBar.finish();  (yes || function(){}).call(this, result.data, result.status, result.request); })
        .catch(function(error) { iView.LoadingBar.error(); (err || function(){}).call(this, error); });
      break;
    case "post": 
      instarg.defaults.transformRequest = [PostLocalData];
      instarg.post(url, data, { headers: { 'Content-Type': REQUEST_HEAD } })
        .then(function(result) { iView.LoadingBar.finish(); (yes || function(){}).call(this, result.data, result.status, result.request); })
        .catch(function(error) { iView.LoadingBar.error(); (err || function(){}).call(this, error); });
      break;
  };
};

/** 判断是否为空（NULL，""，" "） */
var isNullOrEmpty = function(value) { return !(value != null && value != undefined && value.replace(/^\s+|\s+$/gm,'') != ""); }

/** 数据签名 */
var dataMakeSign = function(data, akeys) {
  var signd = [];
  data.timestamp = (new Date()).getTime();
  (akeys + ",timestamp").split(',').forEach(function(key) { signd.push(key+"="+data[key]); });
  data.sign = JSMD5(data.timestamp + SIGNKEY["K0"] + signd.join("&"));
  return data;
};

/** 接口基础函数 */
var req_core = function(){ return this; };
/**
 * 基础请求函数实现
 * @param url    string 请求命令，也可以是完整的请求地址
 * @param yes  function 请求成功回调执行[result,status,JsXHR]
 * @param err  function 请求异常回调执行[error]
 */
req_core.get = function(url, yes, error, timeout) {
  new HttpClient("get", url, null, yes, error, timeout);
};
/**
 * 基础请求函数实现
 * @param url    string 请求命令，也可以是完整的请求地址
 * @param data     json 请求数据，GET组合至URL地址请求
 * @param yes  function 请求成功回调执行[result,status,JsXHR]
 * @param err  function 请求异常回调执行[error]
 */
req_core.post = function(url, data, yes, error, timeout) {
  new HttpClient("post", url, data, yes, error, timeout);
};

/** BEGIN 授权接口 ========================================================= */
var api_auth = function() { return this; };
/**
 * 微信 渠道推广授权绑定
 * @param data    object 绑定数据 { code:微信授权CODE, channel:所属渠道, deviceid:绑定用户标识 }
 * @param cback  function 接口回调函数
 */
api_auth.wxbind = function(data, cback) {
  data.type = 5;
  data.sign = JSMD5(data.channel.toString() + data.code.toString() + SIGNKEY['K'+data.channel]);
  req_core.post(AUTH_API + "cpl.auth_bind", data, cback); 
};
/**
 * 支付宝 授权绑定
 * @param code     string 微信授权CODE
 * @param cback  function 接口回调函数
 */
api_auth.alibind = function(code, cback) {
  var sign = JSMD5(code.toString() + SIGNKEY["K0"]);
  req_core.post(AUTH_API + "cpl.aliuser_auth", { code: code, sign: sign }, cback);
};
/**
 * 授权下载地址
 * @param channel   string 渠道
 * @param cback  function 接口回调函数
 */
api_auth.downurl = function(channel, cback) {
  var data = { channel: channel, sign: JSMD5(channel.toString() + SIGNKEY['K'+channel]) };
  req_core.post(DATA_API + "cpl.downurl", data, cback);
};
/** END ========================================================= */

/** BEGIN 红包接口 ========================================================= */
var api_redpkg = function() { return this; };
/**
 * 微信 授权绑定
 * @param code     string 微信授权CODE
 * @param cback  function 接口回调函数
 */
api_redpkg.auth = function(code, cback) {
  var sign = JSMD5(code.toString() + SIGNKEY["K0"]);
  req_core.post(AUTH_API + "cpl.wxuser_auth", { code: code, sign: sign }, cback); 
};
/**
 * 获取红包待兑换领取 的 红包记录
 * @param userid   string 玩家ID
 * @param cback  function 接口回调函数
 */
api_redpkg.getlist = function(userid, cback) {
  if (+userid <= 0) { return ; }
  var data = { player_id: userid, type: 5 };
  var params = new dataMakeSign(data, "player_id,type");
  req_core.post(DATA_API + "fetch.redpkg_excharge", params, cback);
};
/**
 * 获取已领取红包用户交易记录
 * @param userid   string 玩家ID
 * @param cback  function 接口回调函数
 */
api_redpkg.received = function(userid, cback) {
  if (+userid <= 0) { return ; }
  var data = { player_id: userid, page: 1, size: 20 };
  var params = new dataMakeSign(data, "player_id,page,size");
  req_core.post(DATA_API + "fetch.redpkg_receive", params, cback);
};
/**
 * 红包兑换领取
 * @param userid   string 玩家ID
 * @param expsid   string 兑换ID
 * @param money    string 兑换额度
 * @param cback  function 接口回调函数
 */
api_redpkg.excharge = function(userid, expsid, money, cback) {
  if (+userid <= 0) { return ; }
  var data = { player_id: userid, expid: expsid, money: money };
  var params = new dataMakeSign(data, "player_id,expid,money");
  req_core.post(DATA_API + "trade.redpkg_receive", params, cback);
};
/** END ========================================================= */

export default { get: req_core.get, post: req_core.post, auth: api_auth, redpkg: api_redpkg };



// WEBPACK FOOTER //
// ./src/assets/js/request.js